import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BackupIcon(props: IconProps) {
    return <Icon {...props} iconKey={"backup"}/>
}
